"use client";

import { c as _c } from "react/compiler-runtime";
import { useClient } from "@repo/design-system/utils/client/client";
import { clientConfig } from "~/setup/client";
import { env } from "~/setup/env";
export function useClientLocales() {
  const $ = _c(3);
  const client = useClient();
  if (!(client && client in clientConfig)) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = clientConfig[env.CLIENT]?.locales ?? [];
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== client) {
    t0 = clientConfig[client as keyof typeof clientConfig]?.locales ?? [];
    $[1] = client;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}